import actions from "./actions";

const setCart = actions.setCart;
const validateCart = actions.validateCart;

export default { setCart, validateCart };
